import { vars } from "@imwebme/clay-token";
import type { Ref } from "react";
import { forwardRef } from "react";
import type { ModalHeaderProps } from "..";
import { Flex, Heading, IconButton } from "..";
import { useCloseModal } from "./Modal.providers";

export const ModalHeader = forwardRef(
  (
    {
      type = "leftAlign",
      title,
      backButton,
      closeButton,
      onClickBackButton,
      onClickCloseButton,
      text,
      subtle,
    }: ModalHeaderProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const setClose = useCloseModal();
    const headingTextForDeprecated = title || text;

    return (
      <Flex.Column
        position="relative"
        ref={ref}
        padding={`${vars.spacing[4]} ${vars.spacing[4]} 0`}
      >
        {backButton && (
          <IconButton
            variant="secondary"
            size="small"
            icon={
              // ArrowPrev
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                color="inherit"
              >
                <path
                  d="M13.3334 8.00002H2.66669M2.66669 8.00002L8.00002 13.3334M2.66669 8.00002L8.00002 2.66669"
                  stroke="currentColor"
                  strokeWidth="1.2"
                  vectorEffect="non-scaling-stroke"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            onClick={onClickBackButton}
            sx={{
              position: "absolute",
              left: vars.spacing[4],
            }}
          />
        )}

        {headingTextForDeprecated && (
          <Heading
            size="xLarge"
            align={type === "centerAlign" ? "center" : "default"}
            text={headingTextForDeprecated}
            subtle={subtle}
            sx={{
              paddingTop: vars.spacing[type === "leftAlign" && backButton ? 10 : 2],
              paddingLeft: vars.spacing[2],
              paddingRight: vars.spacing[2],
            }}
          />
        )}

        {closeButton && (
          <IconButton
            variant="secondary"
            size="small"
            icon={
              // XClose
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                color="inherit"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  strokeWidth="1.2"
                  vectorEffect="non-scaling-stroke"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            onClick={() => {
              setClose();
              onClickCloseButton?.();
            }}
            sx={{
              position: "absolute",
              right: vars.spacing[4],
            }}
          />
        )}
      </Flex.Column>
    );
  },
);

ModalHeader.displayName = "ModalHeader";
